import React, { useRef } from 'react'
import {
  APIENDPOINT,
  APIENDPOINTforCareers,
  checkRouteForCareers,
  getCWPEnvironmentForURL,
  sanitizeHTML,
} from '../../../../utils/common-utils'
import { CardImageOnlyProps } from './CardImageOnly.type'
import { FeatureFlag } from '../Card/FeatureFlag'

export const CardImageOnly = (props: CardImageOnlyProps) => {
  const { componentSpacing, cardLimit, cardList, cardDescription, bgImageSrc, bgImagePosition } =
    props

  const env = getCWPEnvironmentForURL(window.location.href)

  const isCareers = checkRouteForCareers(window.location.href)

  const linkRef = useRef<HTMLAnchorElement>(null)

  const cardListId = crypto.randomUUID()

  if (!cardList) {
    return null
  }

  return (
    <>
      <style
        type='text/css'
        dangerouslySetInnerHTML={{
          __html: `
      #a${cardListId}.card-grid-component { 
          background: ${bgImageSrc ? `url(${bgImageSrc})` : 'none'}; 
          background-size: ${bgImagePosition || 'cover'}; }
      `,
        }}
      />
      <section
        id={`a${cardListId}`}
        className={`card-grid-component card-image-only-container ${componentSpacing}`}
        data-limit={cardLimit}
      >
        <div
          className='u-sizeConstrained u-sm-flexCol u-sm-flexJustifyCenter'
          data-testid={props.testId ?? null}
        >
          {cardDescription && (
            <div
              className='card-description Content u-marginBottom20'
              dangerouslySetInnerHTML={{ __html: sanitizeHTML(cardDescription) }}
            />
          )}
          <div className='card-list-wrapper u-sm-flex u-sm-flexCol u-marginBottom20'>
            {cardList.map(card => {
              const { featureFlag, cardContent } = card
              const cardValues = cardContent || {}
              const cardImagePath = cardValues.cardImage
                ? cardValues.cardImage
                : `${
                    APIENDPOINT(getCWPEnvironmentForURL(window.location.toString())).baseGallery
                  }/content/gallery/ampmicrosites/card-default-image.png`

              const urlWithBase = isCareers
                ? `${APIENDPOINTforCareers(env).base.slice(0, -1)}${cardValues.url}`
                : `${APIENDPOINT(env).base.slice(0, -1)}${cardValues.url}`
              return (
                <a
                  key={cardValues.heading}
                  href={cardValues.url?.startsWith('http') ? cardValues.url : urlWithBase}
                  className='u-linkClean Card-Border'
                  data-analytics={cardValues.dataAnalytics}
                  ref={linkRef}
                  aria-label={cardValues.heading}
                  onMouseDown={e => {
                    e.stopPropagation()
                    e.preventDefault()
                  }}
                >
                  <div
                    className={
                      'Card Card--withHeader u-flex u-flexCol u-padding0 u-posRelative u-bgColorWhite u-sizeFull Card--noShadow'
                    }
                  >
                    {featureFlag && (
                      <FeatureFlag
                        backgroundColor={featureFlag.backgroundColor}
                        label={featureFlag.label}
                      />
                    )}
                    <div className='Card-header Card-headerBackgroundImage Card--redesign card-image Card-body'>
                      {cardImagePath && <img src={cardImagePath} alt={cardValues.heading} />}
                    </div>
                  </div>
                </a>
              )
            })}
          </div>
        </div>
      </section>
    </>
  )
}
